var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToncoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
    fill: "#08C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.435 13.217h11.217c.397 0 .794.059 1.208.252.497.231.76.596.945.866a2.517 2.517 0 0 1 .37 1.317c-.001.426-.102.89-.33 1.296l-.006.011-7.087 12.174a.87.87 0 0 1-1.506-.005L12.288 16.98l-.006-.01c-.16-.262-.406-.668-.449-1.192a2.373 2.373 0 0 1 1.355-2.34c.47-.219.946-.22 1.246-.22Zm4.696 1.74h-4.696c-.309 0-.427.018-.51.057a.622.622 0 0 0-.358.622c.006.074.037.158.214.451a.904.904 0 0 1 .011.019l5.339 9.321v-10.47Zm1.739 0v10.516l5.461-9.382a.949.949 0 0 0 .104-.439.772.772 0 0 0-.09-.37 1.404 1.404 0 0 0-.138-.178.255.255 0 0 0-.082-.059 1.04 1.04 0 0 0-.473-.089H20.87Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToncoin);
export default __webpack_public_path__ + "static/media/toncoin.6fc0415f.svg";
export { ForwardRef as ReactComponent };